import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NivelRiscComponent } from './nivel-risc.component';
import { AddNivelRiscComponent } from './add-nivel-risc/add-nivel-risc.component';
import { EditNivelRiscComponent } from './edit-nivel-risc/edit-nivel-risc.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        NivelRiscComponent,
        AddNivelRiscComponent,
        EditNivelRiscComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [NivelRiscComponent],
})
export class NivelRiscModule { }
